import Vue from 'vue';

import * as mutationTypes from '@/types/mutationTypes';
import * as getterTypes from '@/types/getterTypes';
import { areRouteParamsEqual } from '@/tools/areRouteParamsEqual';
const historyActions = {
	goBack: 'goBack',
	goForward: 'goForward',
	pushNew: 'pushNew',
};

export default {
	state: {
		stack: [],
		lastAction: null,
		map: {
			/* [vueRouterKey]: stackEntry */
		},
		articleVisits: {
			/* [articleID/exhibitionID]: { ...props } */
		},
		index: -1,
	},
	getters: {
		[getterTypes.historyPrev](state) {
			return state.stack[state.index - 1] || null;
		},
		[getterTypes.historyCur](state) {
			return state.stack[state.index] || null;
		},
		[getterTypes.historyNext](state) {
			return state.stack[state.index + 1] || null;
		},
	},
	mutations: {
		[mutationTypes.historyUpdate](state, payload) {
			const vueRouterHistoryKey = payload.historyKey || (window.history.state && window.history.state.key);
			const revisitedEntry = state.map[vueRouterHistoryKey];
			let committedEntry = null;

			// back/forwards in history to another recorded entry
			// check that the revisited entry is a different target OR is identical (reload)
			if (
				revisitedEntry &&
				(revisitedEntry.index !== state.index || areRouteParamsEqual(payload, revisitedEntry))
			) {
				state.lastAction =
					revisitedEntry.index < state.index ? historyActions.goBack : historyActions.goForward;
				committedEntry = revisitedEntry;
			}
			// pushing new history entry
			else {
				const { exhibitionID, tourID, articleID, tourPosition } = payload;
				const newEntry = (committedEntry = {
					// key will be set from router afterEach hook
					historyKey: undefined,
					index: state.index + 1,
					exhibitionID,
					tourID,
					tourPosition,
					articleID,
				});

				const removedForwardEntries = state.stack.slice(newEntry.index, Infinity, newEntry);

				// clear forward entries from state.map
				for (const entry of removedForwardEntries) {
					state.map[entry.historyKey] = undefined;
				}

				state.lastAction = historyActions.pushNew;
			}
			// update history stack
			state.stack.splice(committedEntry.index, 1, committedEntry);
			state.index = committedEntry.index;
		},
		[mutationTypes.historySetCurrentKey](state) {
			const currentEntry = state.stack[state.index];

			if (currentEntry.historyKey) {
				// // console.log('#history not set');
				return;
			}

			currentEntry.historyKey = window.history.state && window.history.state.key;

			Vue.set(state.map, currentEntry.historyKey, currentEntry);
			// // console.log('#history set')
		},
		// Listens on set Article
		[mutationTypes.setArticleID](state, { article }) {
			const articleID = article.id || article;
			const currentEntry = state.stack[state.index];

			if (!currentEntry.articleID) {
				// initial page load
				currentEntry.articleID = articleID;
				currentEntry.exhibitionID = this.state.currentExhibitionID;
			}
		},
		[mutationTypes.scrollSavePagePosition](state, { historyKey, exhibitionID, articleID, scroll }) {
			const entry = state.map[historyKey];

			if (entry) {
				entry.scroll = scroll;
			}

			if ((this.state.dataSourceCFG.configWebClient.navigation || {}).alwaysRestoreScroll) {
				const articleKey = `${exhibitionID}/${articleID}`;
				const visit = state.articleVisits[articleKey] || {};

				Vue.set(visit, 'scroll', scroll);
				Vue.set(state.articleVisits, articleKey, visit);
			}
		},
	},

	actions: {},
};
